module.exports = __webpack_public_path__ + "static/media/hamburguer.4f1c1de8.svg";